<template>
    <div class="overflow-x-hidden">
        <section
            class="why-section text-center  grid flex flex-wrap justify-content-center align-items-center py-2 px-4 md:px-6 ">
            <div class="col-10 md:py-4">
                <div class="flex align-items-center justify-content-center gap-3 mb-2">
                    <img src="@/assets/Images/flowers.png" alt="Why ILearn'd" class="why-icon">
                    <!-- <span class="badge mb-0">Why?</span> -->
                </div>
                <h2 class="mb-2 LandingPage-Title">
                    Why ILearn'd Tutors
                </h2>
                <p class="Paragraph-Regular mx-auto">
                    In Sri Lanka, education means everything but finding the right tutor hasn’t always been easy.
                    ILearn’d Tutors changes that by making it simple and reliable for students to connect with trusted,
                    verified tutors across the island.
                </p>
            </div>
        </section>
    </div>
</template>
<style scoped>
.why-icon {
    width: 100px;
    height: 100px;
    object-fit: contain;
}

/* Responsive styles */
@media (max-width: 768px) {
    .why-icon {
        width: 80px;
        height: 80px;
    }
}

@media (max-width: 480px) {
    .why-icon {
        width: 60px;
        height: 60px;
    }
}
</style>